import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import it from './it';
import en from './en';
import ar from './ar';

const dictionaries = { it, en, ar };
export const LANGUAGES = [
  { code: 'it', label: 'IT' },
  { code: 'en', label: 'EN' },
  { code: 'ar', label: 'AR' },
];

const RTL_LANGS = ['ar'];

const LanguageContext = createContext({ lang: 'it', setLang: () => {}, t: (k) => k });

const getPath = (obj, path) => path.split('.').reduce((o, k) => (o == null ? undefined : o[k]), obj);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    if (typeof window === 'undefined') return 'it';
    const stored = window.localStorage.getItem('fp_lang');
    if (stored && dictionaries[stored]) return stored;
    const browser = (navigator.language || 'it').slice(0, 2).toLowerCase();
    return dictionaries[browser] ? browser : 'it';
  });

  useEffect(() => {
    try {
      window.localStorage.setItem('fp_lang', lang);
      document.documentElement.lang = lang;
      document.documentElement.dir = RTL_LANGS.includes(lang) ? 'rtl' : 'ltr';
    } catch (e) {
      /* noop */
    }
  }, [lang]);

  const value = useMemo(() => {
    const dict = dictionaries[lang] || dictionaries.it;
    const t = (key, fallback) => {
      const v = getPath(dict, key);
      if (v === undefined) return fallback !== undefined ? fallback : key;
      return v;
    };
    return { lang, setLang, t, isRTL: RTL_LANGS.includes(lang) };
  }, [lang]);

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLang = () => useContext(LanguageContext);
